import React, { useState } from "react";
import {
  Button,
  TextField,
  Snackbar,
  Slide,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { objectAsParams } from "../../helpers";

const ScanFile = ({ id_guia, socketId }) => {
  const [filename, setFilename] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("1");
  const [snackBar, setSnackBar] = useState({ open: false, sbMsg: "" });

  const onScan = () => {
    if (filename && filename.length > 0 && tipoDocumento !== '') {
      const auth = localStorage.getItem("tt");
      let params = objectAsParams({
        socketid: socketId,
        auth,
        typeSubmit: "documento_guia",
        filename,
        mensaje: `ESCANEO-ARCHIVOS-IDGUIA-${id_guia}`,
        id_guia,
        tipoDocumento
      });
      window.location.assign(`twain-nodejs://received?${params}`);
    } else {
      setSnackBar({
        open: true,
        sbMsg: "Porfavor de seleccionar tipo y poner un nombre al archivo",
      });
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        margin: "5px 0px",
        justifyContent: "flex-end",
      }}
    >
      <FormControl style={{ width: 250, margin: '0px 5px' }} variant="outlined" className="form-field">
        <TextField
          variant="outlined"
          value={filename}
          label="Nombre del archivo*"
          placeholder="Nombre del archivo*"
          onChange={(e) => {
            setFilename(e.target.value);
          }}
        />
      </FormControl>
 
      <FormControl style={{width: 250, margin: '0px 5px' }} variant="outlined" className="form-field">
        <InputLabel>Tipo de Precio*</InputLabel>
        <Select
          value={tipoDocumento}
          onChange={(e) => {
            setTipoDocumento(e.target.value);
          }}
        >
          <MenuItem value={"1"}>Factura</MenuItem>
          <MenuItem value={"2"}>Remision</MenuItem>
          <MenuItem value={"3"}>Orden Salida</MenuItem>
          <MenuItem value={"4"}>Vale tarima</MenuItem>
          <MenuItem value={"5"}>Otro</MenuItem>
        </Select>
      </FormControl>
 
      <Button color="primary" variant="contained" onClick={onScan}>
        Escanear Documento
      </Button>

      <Snackbar
        open={snackBar.open}
        onClose={() => {
          setSnackBar({ open: false, sbMsg: "" });
        }}
        TransitionComponent={Slide}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">{snackBar.sbMsg}</span>}
      />
    </div>
  );
};

export default ScanFile;
